<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M10.333 13.3333H3.66634V4.66665C3.66634 4.29998 3.36634 3.99998 2.99967 3.99998C2.63301 3.99998 2.33301 4.29998 2.33301 4.66665V13.3333C2.33301 14.0666 2.93301 14.6666 3.66634 14.6666H10.333C10.6997 14.6666 10.9997 14.3666 10.9997 14C10.9997 13.6333 10.6997 13.3333 10.333 13.3333ZM13.6663 10.6666V2.66665C13.6663 1.93331 13.0663 1.33331 12.333 1.33331H6.33301C5.59967 1.33331 4.99967 1.93331 4.99967 2.66665V10.6666C4.99967 11.4 5.59967 12 6.33301 12H12.333C13.0663 12 13.6663 11.4 13.6663 10.6666ZM12.333 10.6666H6.33301V2.66665H12.333V10.6666Z"
      fill="url(#paint0_linear_139_11532)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_139_11532"
        x1="2.33301"
        y1="1.33331"
        x2="15.5224"
        y2="12.468"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.456596" stop-color="#DF252A" />
        <stop offset="1" stop-color="#A20004" />
      </linearGradient>
    </defs>
  </svg>
</template>
